import React, { useState, forwardRef, useImperativeHandle } from "react";

const SignatureRenderer = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);

    function trimMiddle(str) {
        if (!str || str.length <= 40) return str;
        return `${str.slice(0, 30)}.....${str.slice(-15)}`;
    }

    const canceledSpan = props.node.data
        ? props.node.data.canceled
            ? <span className="canceled-payment">{trimMiddle(value)}</span>
            : <>{trimMiddle(value)}</>
        : <></>;

    useImperativeHandle(ref, () => ({
        refresh(params) {
            const val = params.value;
            if (val != undefined) {
                setValue(trimMiddle(val));
                props.node.setDataValue(props.column.colId, trimMiddle(val));
            }
            return true;
        }
    }));

    return <span>{value ? canceledSpan : <></>}</span>;
});

export default SignatureRenderer;
